// ---------------------------------------------------------------------------
// Regionen MIT eigener Landingpage — die eine Quelle dafuer.
//
// Wird von vier Stellen gelesen, die sonst auseinanderlaufen wuerden:
//   * pages/RegionPage.jsx        — rendert die Seite
//   * pages/Home.jsx              — Kacheln "Beliebte Regionen"
//   * components/Footer.jsx       — Regionsliste
//   * scripts/gen-sitemap-static.mjs — Sitemap, Prerendering, Render-Rewrites
// Eigene Datei statt Export aus RegionPage.jsx, weil Home und Footer sonst den
// kompletten RegionPage-Chunk mitziehen wuerden (Route-Level-Splitting, App.js).
//
// ACHTUNG, das Format ist maschinenlesbar: Der Sitemap-Generator liest die Slugs
// mit dem Muster /\{\s*slug:\s*"…"/ aus dieser Datei (Node kann sie nicht
// importieren — package.json setzt kein "type": "module"). Ein Eintrag muss
// also mit `{ slug: "…"` beginnen. Weicht das Format ab, bricht der Build ab
// statt still eine kuerzere Liste auszuliefern.
//
// Eine neue Region braucht IMMER beides: den Eintrag hier UND einen in
// backend/routers/regionen.py. Der Build vergleicht die zwei Listen und bricht
// bei Abweichung ab — ohne Backend-Eintrag laedt die Seite, zeigt aber keine
// amtlichen Zahlen. Dazu die Texte in allen 7 Sprachdateien (regionpage.r_*).
//
// Die Felder muessen zusammenpassen:
//   slug         URL und Backend-Schluessel (REGIONEN in backend/routers/regionen.py)
//   name         exakter Suchfilter-Wert (regionGeo.js — case-sensitiv!)
//   i18nBase     Prefix der Textkeys (regionpage.r_<base>_intro …)
//   locationSlug Koordinaten + mehrsprachige Labels (data/cyprusLocations.js)
//   bezirkLabel  Bezirk fuer die amtlichen Zahlen; null = kein eigener Bezirk
//                (Troodos liegt ueber mehreren — die Seite zeigt dann ehrlich
//                den landesweiten Index)
// ---------------------------------------------------------------------------
export const REGION_PAGES = [
  { slug: "limassol", name: "Limassol", i18nBase: "r_limassol", locationSlug: "limassol", bezirkLabel: "Limassol" },
  { slug: "paphos", name: "Paphos", i18nBase: "r_paphos", locationSlug: "paphos", bezirkLabel: "Paphos" },
  { slug: "nicosia", name: "Nicosia", i18nBase: "r_nicosia", locationSlug: "nicosia", bezirkLabel: "Nicosia" },
  { slug: "larnaca", name: "Larnaca", i18nBase: "r_larnaca", locationSlug: "larnaca", bezirkLabel: "Larnaca" },
  { slug: "ayia-napa", name: "Ayia Napa", i18nBase: "r_ayia_napa", locationSlug: "ayia-napa", bezirkLabel: "Famagusta" },
  { slug: "protaras", name: "Protaras", i18nBase: "r_protaras", locationSlug: "protaras", bezirkLabel: "Famagusta" },
  { slug: "troodos", name: "Troodos", i18nBase: "r_troodos", locationSlug: "troodos", bezirkLabel: null },
  { slug: "pissouri", name: "Pissouri", i18nBase: "r_pissouri", locationSlug: "pissouri", bezirkLabel: "Limassol" },
];

// Ziel-Link fuer einen Regionsnamen: die Landingpage, wenn es eine gibt —
// sonst null. Aufrufer entscheiden dann selbst (in der Regel: gefilterte Suche).
//
// Nicht jede Region der Karte hat eine Seite: `Polis Chrysochous` steht in
// regionGeo.js, hat aber weder eigenen Bestand noch eigene amtliche Reihe —
// dafuer waere eine Landingpage eine duenne Seite. (`Kyrenia` stand hier bis
// zum 07.08.2026 daneben; es ist inzwischen ganz entfallen, weil der Bezirk im
// besetzten Norden liegt.)
export function regionPagePath(name) {
  const treffer = REGION_PAGES.find((r) => r.name === name);
  return treffer ? `/region/${treffer.slug}` : null;
}
